import React from "react";
import { Updater } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme";
import {
  ExperienceFe,
  ExperienceListVariationDto,
} from "@intelligems/ig-types";
import { GenericExperienceFe } from "@intelligems/ig-types/fe-only/experiences";
import { Grid } from "@mui/material";
import { IgAlertSimpleInverted } from "@src/components/Utils/IgAlertSimpleInverted";
import { RolloutAnalyticsTable } from "@src/features/analytics/tables/RolloutsAnalyticsTable";
import { theme } from "@src/theme";
import { personalizationRollingOutTests } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

interface RolloutsGroupSelectionProps {
  experience: ExperienceFe | GenericExperienceFe;
  variations: (Omit<ExperienceListVariationDto, "experienceId"> & {
    experienceId?: string;
  })[];
  selectedVariationId: string;
  setSelectedVariationId: Updater<string>;
}
export const RolloutsGroupSelection = ({
  experience,
  setSelectedVariationId,
  selectedVariationId,
  variations,
}: RolloutsGroupSelectionProps) => {
  return (
    <Grid container item rowSpacing={2}>
      <Grid item>
        <IgTypography sx={{ color: theme.palette.text.secondary }}>
          Step through this wizard to roll out a test’s best performing group,
          by applying changes directly to Shopify or creating a live Experience.{" "}
          <IgTypography
            igStyle={"link"}
            sx={{ fontWeight: 400 }}
            onClick={() => {
              openNewTab(
                personalizationRollingOutTests,
                "Rolling Out Tests" // check that this is the correct mixpanel tracker
              );
            }}
          >
            Find out more.
          </IgTypography>
        </IgTypography>
      </Grid>
      <Grid item container sx={{ marginBottom: "-25px" }} mt={2}>
        <IgTypography>
          First, which test group would you like to roll out?
        </IgTypography>
      </Grid>

      <RolloutAnalyticsTable
        experience={experience}
        variations={variations}
        selectedVariationId={selectedVariationId}
        setSelectedVariationId={setSelectedVariationId}
      />
      <Grid item mt={4}>
        <IgAlertSimpleInverted
          severity={"info"}
          message={
            "You can roll out multiple groups by repeating the Rollout wizard as many times as you’d like.\n" +
            "This is useful when one group performs best for audience A, and another group performs best for audience B. "
          }
          alertKey={"rollouts-group-selection"}
        />
      </Grid>
    </Grid>
  );
};
